export default defineNuxtPlugin(() => {
    const apiKey = useRuntimeConfig().public.googleMapsApiKey;
    
    const geocodeAddress = async (address: string) => {
      try {
        const response = await fetch(
          `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(address)}&key=${apiKey}`
        );
        const data = await response.json();
        if (data.status === "OK") {
          return data.results[0].geometry.location; // Returns { lat, lng }
        } else {
          throw new Error(`Geocode error: ${data.status}`);
        }
      } catch (error) {
        console.error("Geocoding error:", error);
        return null;
      }
    };
  
    return {
      provide: {
        geocodeAddress,
      },
    };
  });
  